import React from 'react';
import { List } from 'react-content-loader';
import styled from 'styled-components';

const Container = styled.div`
  width: 50%;
  margin: 50px auto;
`;

export default function ItemLoader() {
  return (
    <Container>
      <List width={250} />
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/ItemLoader/ItemLoader.js